<template>
    <div>

        <footer>

            <div class="container-fluid legal-info texto row">
                <div class="col d-flex px-5 py-3">
                    <div>Copyright 2021 AbaKan *</div>
                    <div class="ml-auto pr-4">
                        <!-- <router-link to="/condiciones-generales" class="pr-3">Condiciones Generales</router-link> -->
                        <a href="https://fondos-sociales.com/pdf/privacidad.pdf" target="_blank">Politica de Privacidad</a>
                        <a href="https://fondos-sociales.com/pdf/cookies.pdf" target="_blank">Cookies</a>

                        <!-- <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button> -->

                        <!-- <router-link to="/avisolegal" class="pr-3">Aviso Legal</router-link>
                        <router-link to="/condiciones" class="pr-3">Condiciones Generales</router-link>
                        <router-link to="/politica" class="pr-3">Política de Privacidad</router-link>
                        <router-link to="/cookies" class="pr-3">Cookies</router-link>
                        <router-link to="/contacto" class="pr-3">Contacto</router-link>    -->
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

export default {
    name: 'AppFooter',
    components: {

    },
    data: () => ({
        titulo: 'Footer Aplicacion',

    }),
    methods: {

    },

}
</script>
